module.exports = __webpack_public_path__ + "img/Interest-Trade-in-Mockup.e8dece21.svg";